export default {
  'supporting-points': {
    'course-title': 'Supporting the Points Introduction',
    'course-name': 'Section 3 <span class="unit-title">Supporting the Points<br/>Introduction<span>',
    'course-video': {
      'title': 'Section 3 SUPPORTING THE POINTS<br/>50:10 - 56:51 3A DEDUCTIVE REASONING ex 3A-1idetifying deductive arguments +3A-2<br/> summarizing deductive arguments + 3A-3 finding deductive arguments embedded in<br/> prose',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': '3 Lecture'
    },
    'exercise-descripton': `<p>As you now know, the point at the top of the pyramid will raise a question in the reader’s mind, which you are obliged to answer logically on the line below. Your reasoning may be presented in only one of two ways: as a deductive argument or as an inductive grouping.</p>
<br/><p>Here is how the two forms of reasoning differ:</p>
<br/><br/>
<div>
  <div class="intro-side">
    <h3>Deductive Resoning</h3>
    <ul>
    <li>The first point makes a statement</li>
    <li>The second point comments on the first</li>
    <li>The third point is the “therefore” point</li>
    <li>The point above summarizes the grouping 
      by taking the last point, putting it above, 
      and adding a ‘because’ to cover the other 
      points</li>
      </ul><br/><br/>
    <h3>Inductive Resoning</h3>
    <ul>
    <li>Ideas are all of the same kind
      (have the same subject or the same predicate)</li>
    <li>They are all able to be described by the 
      same general plural noun (e.g., reasons, problems, steps)</li>
    <li>The point above states the insight gleaned 
      by seeing the similarity in the ideas</li>
      </ul><span></span>
  </div>
  <div class="intro-side"><img src="/assets/images/structure-3zero.png" alt="Original structure" /></div>
</div>
<br/><br/>
<p><br/><br/>The rule of thumb is</p>
<ul>
<li><strong>In deduction - the second point comments on the first</strong></li>
<li><strong>In induction - the points are separate but of the same kind</strong></li>
</ul><br/>
<p>Very few people have problems in working out their reasoning once they know which form they are using. Accordingly, the skill you need to develop is the ability to distinguish deduction from induction, and recognize the rules related to each. </p>
<br/><p>Chapters 2 and 5 in the textbook “The Minto Pyramid Principle: Logic in Writing, Thinking and Problem Solving,” explain the difference and the rules. The purpose of the exercises that follow is to give you practice in distinguishing between the two forms and recognizing their permissible variations.</p>
<ul>
<li>3A presents examples of how deductive arguments can look, both in structure and when developed in writing</li>
<li>3B gives the same insights into inductive arguments</li>
</ul>`,
    'next-course-button': 'Proceed to 3A-1',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3zero/supportingPoints/i18n/en.js